
    const html = "<div> <ul class=\"nav nav-{{tabset.type || 'tabs'}}\" ng-class=\"{'nav-stacked': vertical, 'nav-justified': justified}\" ng-transclude></ul> <div class=tab-content> <div class=tab-pane ng-repeat=\"tab in tabset.tabs\" ng-class=\"{active: tabset.active === tab.index}\" uib-tab-content-transclude=tab> </div> </div> </div> ";
    angular.module('ng').run(['$templateCache', function($templateCache){
      $templateCache.put('uib/template/tabs/tabset.html', html);
    }]);
    module.exports = 'uib/template/tabs/tabset.html';
  